<body id="page-top" class="landing-page">
<nav class="navbar navbar-default fixed-top " role="navigation">
            <div class="container">
                <div class="navbar-header mb-5">
                    <a class="navbar-brand" href="#page-top"><img id="logo_img" src="./assets/logo-mclab.png"  alt="McLab"></a>
                </div>
                <div id="navbar">
                    <ul class="nav navbar-right mb-5">
                        <li class="active"><a class="page-scroll" href="#page-top">Inicio</a></li>
                        <li><a class="page-scroll" href="#services">Servicios</a></li>
                        <!-- <li><a class="page-scroll" href="">Desarrollo</a></li> -->
                        <!--li><a class="page-scroll" href="#company">La Empresa</a></li>-->
                        <!--li><a class="page-scroll" href="#parners">Asociados</a></li>-->
                        <!--li><a class="page-scroll" href="#other_services">Otros Servicios</a></li>-->
                        <li class=""><a class="page-scroll" href="#contact">Contacto</a></li>
                        <li>
                        </li>
                    </ul>
                </div>
            </div>
</nav>
  <div id="inSlider" class="carousel carousel-fade slide " data-bs-ride="carousel" data-bs-pause="False" >
    <div class="carousel-indicators">
        <button type="button" data-bs-target="#inSlider" data-bs-slide-to="0" class="active"
            aria-current="true" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#inSlider" data-bs-slide-to="1"
            aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#inSlider" data-bs-slide-to="2"
            aria-label="Slide 3"></button>
    </div>
    <div class="carousel-inner">
         <!--Slide 1-->
        <div class="carousel-item  header-back one">
            <div class="carousel-caption   ms-5">
                <h1 class="ms-4">Ingeniería de Redes:<br>Integración, Modificación<br>y Optimización.<br></h1>
                <p class="ms-4">Análisis in-situ de redes con tecnologías GSM/WCDMA/LTE.</p>
                <p class="ms-4"><a class="page-scroll btn btn-lg btn-primary" href="#services"  role="button">Ingeniería</a></p>
            </div>
        </div>
        <!--Slide 2 d-none d-md-block-->
        <div class="carousel-item   header-back two">
            <div class="carousel-caption  ms-5">
                <h1 class="ms-4">Análisis de Redes <br> Mediciones en terreno.</h1>
                <p class="ms-4">Análisis in-situ de redes con tecnologías GSM/WCDMA/LTE.</p>
                <p class="ms-4"><a class="page-scroll btn btn-lg btn-primary" href="#services" role="button">Medición</a></p>
            </div>
        </div>
        <!--Slide 3-->
        <div class="carousel-item active header-back three ">
            <div class="carousel-caption   ms-5">
                <h1 class="ms-4">Gestión de procesos<br>Network Operation Center<br></h1>
                <p class="ms-4">Software para gestión y control de operaciones.</p>
                <p class="ms-4">
                    <a class="page-scroll btn btn-lg btn-primary" href="#services" role="button">Software</a>
                </p>
            </div>
            <div class="carousel-image wow zoomIn animated" >
                <img src="./assets/laptop.png" alt="laptop">
            </div>
        </div>
    </div>
</div>

<section id="services" class="white-bg services mb-5">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 text-center">
                <div class="navy-line2"></div>
                <h1></h1>
                <p>McLab es una empresa de servicios de ingeniería y soporte en redes CORE, GSM, WCDMA, LTE, 5G y software de gestión de procesos.</p>
            </div>
            <div class="col-sm-3">
                <h2>Desarrollo de Software</h2>
                <p>Nos esforzamos por estar al día con las tecnologías y nuestro personal se encuentra en constante aprendizaje, impulsando ideas innovadoras con tecnologías de primera calidad, como lo son la Automatización y Robotización de procesos.</p>
                <p><a class="navy-link page-scroll" data-bs-target="#inSlider2" data-bs-slide-to="3" role="button">Detalles »</a></p>
            </div>
            <div class="col-sm-3">
                <h2>Ingeniería de Redes</h2>
                <p>La ingeniería de nuestros servicios consiste en la integración, modificación y optimización de las redes celulares GSM/WCDMA/LTE/5G de diferentes operadoras.</p>
                <p><a class="navy-link page-scroll active" data-bs-target="#inSlider2" data-bs-slide-to="0" role="button">Detalles »</a></p>
            </div>
            <div class="col-sm-3">
                <h2>Mediciones en Terreno</h2>
                <p>McLab proporciona medición y análisis en terreno de la energía, interferencia, accesibilidad, transferencia de datos y mejores servidores para la cobertura en las tecnologías GSM/WCDMA/LTE/5G.</p>
                <p><a class="navy-link page-scroll"  data-bs-target="#inSlider2" data-bs-slide-to="1" role="button">Detalles »</a></p>
            </div>
            <div class="col-sm-3">
                <h2>Gestión de Procesos (NOC)</h2>
                <p>El Servicio de Network Operation Center (NOC) se enfoca en la gestión, control e implementación de soluciones en los procesos, aumentando la eficiencia y reduciendo los costos de las operaciones.</p>
                <p><a class="navy-link page-scroll"  data-bs-target="#inSlider2" data-bs-slide-to="2" role="button">Detalles »</a></p>
            </div>
        </div>

        <div id="inSlider2" class="features carousel carousel-fade slide mb-5" data-bs-ride="carousel">
            <div class="carousel-inner" role="listbox">
                        <div class="carousel carousel-item ">
                            <div class="row">
                                <div class="col-lg-12 text-center">
                                    <div class="navy-line"></div>
                                    <h1>Ingeniería de Redes<br> <span class="navy">Integración, Modificación y Optimización</span> </h1>
                                    <p>Nuestra optimización tiene como objetivo mejorar las métricas (KPI) utilizando de manera eficiente los recursos de red y la entrega de un servicio de alta calidad.</p>
                                </div>
                            </div>
                            <br>
                            <div class="row d-flex">
                                <div class="col-md-3 text-center wow fadeInLeft animated vis-csp">
                                    <div>
                                        <i class="fa fa-wifi features-icon"></i>
                                        <h2>Análisis de redes</h2>
                                        <p>Revisión y corrección de parámetros de red. Recolección y análisis de informes de métricas (KPI) y del rendimiento estándar de la red.</p>
                                    </div>
                                    <div class="m-t-lg">
                                        <i class="fa fa-sliders features-icon"></i>
                                        <h2>Modificación de redes</h2>
                                        <p>Integración, emplazamiento, modificación migración y ampliaciones de redes GSM, WCDMA y LTE junto con dimensionamiento y optimización de E1.</p>
                                    </div>
                                </div>
                                <div class="col-md-6 text-center  wow zoomIn animated vis-csp">
                                    <img src="./assets/mac.png" alt="dashboard" class="img-responsive">
                                </div>
                                <div class="col-md-3 text-center wow fadeInRight animated vis-anir-csp">
                                    <div>
                                        <i class="fa fa-dashboard features-icon"></i>
                                        <h2>Optimización</h2>
                                        <p>Nuestra optimización tiene como objetivo mejorar los KPI utilizando de manera eficiente los recursos de red y la entrega de un servicio de alta calidad.</p>
                                    </div>
                                    <div class="m-t-lg">
                                        <i class="fa fa-refresh features-icon"></i>
                                        <h2>Actualización de software</h2>
                                        <p>Cambio de frecuencias y actualizaciones de software en las redes y sitios GSM, WCDMA y LTE.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="carousel carousel-item">
                            <div class="row">
                                <div class="col-lg-12 text-center">
                                    <div class="navy-line"></div>
                                    <h1>Mediciones y Análisis en Terreno<br> <span class="navy">Redes GSM/WCDMA/LTE</span> </h1>
                                    <p>Desarrollo de sistemas para control de operaciones y procesos.</p>
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-md-3 text-center wow fadeInLeft animated vis-anil-csp">
                                    <div>
                                        <i class="fa fa-sliders features-icon"></i>
                                        <h2>Mediciones</h2>
                                        <p>Mediciones de interior y evaluación comparativa DriveTest.</p>
                                    </div>
                                    <div class="m-t-lg">
                                        <i class="fa fa-signal features-icon"></i>
                                        <h2>Limpieza</h2>
                                        <p>Análisis de espectro y limpieza.</p>
                                    </div>
                                </div>
                                <div class="col-md-6 text-center  wow zoomIn animated vis-csp">
                                    <img src="./assets/antena2.png" alt="dashboard" class="img-responsive">
                                </div>
                                <div class="col-md-3 text-center wow fadeInRight animated vis-anir-csp">
                                    <div>
                                        <i class="fa fa-code-fork features-icon"></i>
                                        <h2>Diseño de Cobertura</h2>
                                        <p>Diseño y optimización de la cobertura junto con el análisis de caída de señales y causal.</p>
                                    </div>
                                    <div class="m-t-lg">
                                        <i class="fa fa-gears features-icon"></i>
                                        <h2>Procesamiento</h2>
                                        <p>Revisión, análisis y procesamiento de cobertura y señales.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="carousel carousel-item active">
                            <div class="col-lg-12 text-center">
                                <div class="navy-line"></div>
                                <h1>Software de Gestión<br> <span class="navy">Network Operation Center (NOC)</span> </h1>
                                <p>Desarrollo de sistemas para control de operaciones y procesos con la finalidad de reducir los tiempos de entrega de información.</p>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-md-3 text-center wow fadeInLeft animated vis-anil-csp">
                                    <div>
                                        <i class="fa fa-area-chart features-icon"></i>
                                        <h2>Dashboard personalizado</h2>
                                        <p>Gráficos, procesos, alarmas, etc. Información requerida por el cliente dispuesta y ordenada según sus necesidades.</p>
                                    </div>
                                    <div class="m-t-lg">
                                        <i class="fa fa-mobile features-icon"></i>
                                        <h2>Diseño responsive</h2>
                                        <p>Visualización de dashboard y procesos en todo tipo de dispositivos como tablets o smartphones.</p>
                                    </div>
                                </div>
                                <div class="col-md-6 text-center  wow zoomIn animated vis-csp">
                                    <img src="./assets/perspective.png" alt="dashboard" class="img-responsive width-height-csp">
                                </div>
                                <div class="col-md-3 text-center wow fadeInRight animated vis-anir-csp">
                                    <div>
                                        <i class="fa fa-line-chart features-icon"></i>
                                        <h2>NOC TV</h2>
                                        <p>Presentación de dashboard y procesos en tiempo real para una mejor gestión, control y respuesta a los sucesos en desarrollo.</p>
                                    </div>
                                    <div class="m-t-lg">
                                        <i class="fa fa-phone features-icon"></i>
                                        <h2>Soporte 24/7</h2>
                                        <p>Monitoreo presencial y remoto las 24 horas del día, los 365 días al año, lo que garantiza la continuidad operativa y el servicio.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                <div class="carousel carousel-item">
                    <div class="row">
                        <div class="col-lg-12 text-center">
                            <div class="navy-line"></div>
                            <h1>Desarrollo de Software<br> <span class="navy">Estamos a la vanguardia</span> </h1>
                            <p>Desarrollo de sistemas sobre tecnologias y lenguajes de programación a la vanguardia.</p>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-md-3 text-center wow fadeInLeft animated vis-anil-csp">
                            <div>
                                <i class="fa fa-cogs features-icon"></i>
                                <h2>Lenguajes de Programación</h2>
                                    <p>Nuestros colaboradores cuentan con habilidades principalmente en los siguientes lenguajes de programación: Python, Php, Javascript, NodeJS, Angular</p>
                            </div>
                            <div class="m-t-lg">
                                <i class="fa fa-cubes features-icon"></i>
                                <h2>Sistemas</h2>
                                <p>Diferentes softwares tecnológicos y herramientas:</p>
                                <p>Splunk, RPA Automation Anywhere, RPA Uipath, Sistemas Operativos (Unix, Windows, OSX), Base de datos relacionales como no relacionales</p>
                            </div>
                        </div>
                        <div class="col-md-6 text-center  wow zoomIn animated vis-csp">
                            <img src="./assets/program.png" alt="dashboard" class="img-responsive">
                        </div>
                        <div class="col-md-3 text-center wow fadeInRight animated vis-anir-csp">
                            <div>
                                <i class="fa fa-code-fork features-icon"></i>
                                <h2>Telecomunicaciones</h2>
                                <p>Nuestro personal capacitado posee experiencia en telecomunicaciones y equipos de Ericsson, Huawei y Cisco, con conocimiento riguroso en su manejo. </p>
                            </div>
                            <div class="m-t-lg">
                                <i class="fa fa-certificate features-icon"></i>
                                <h2>Trayectoria</h2>
                                <p>Profesionales con experiencia en gerencia mejoran procesos y asesoran decisiones.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
&nbsp;&nbsp;&nbsp;&nbsp;
<section id="clients" class="navy-section testimonials " >

    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 text-center">
                <div class="navy-line2"></div>
                <h1>Nuestros Clientes</h1>
                <div class="d-flex justify-content-center clientes">
                    <div >
                        <img alt="image" class="clientes center-block width240-padd-csp" src="./assets/wom.svg">
                    </div>
                    <div class="ms-5">
                        <img alt="image" class="clientes center-block width100-padd-csp" src="./assets/entel_logo_comp_color.png">
                    </div>
                    <div class="ms-5">
                        <img alt="image" class="clientes center-block width80-padd-csp" src="./assets/logo-teknica.png">
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>

<section id="contact" class="gray-section contact d-flex justify-content-center mt-0">
    <div class="container">
        <div class="row m-b-lg">
            <div class="col-lg-12 text-center">
                <div class="navy-line"></div>
                <h1>Contacto</h1>
            </div>
        </div>
        <div class="row m-b-lg d-flex justify-content-center">
            <div class="col-lg-3 col-lg-offset-3">
                <address>
                    <strong><span class="navy">McLab, SpA.</span></strong><br>
                    El Director 6000 of. 207<br>
                    Las Condes, Santiago - CHILE<br>
                    <abbr title="Email">Email:</abbr> contacto@mclab.cl
                </address>
            </div>
            <div class="col-lg-4">
                <p class="text-color">Contáctanos ahora y resolveremos dudas que tengas acerca de nuestros servicios. Agenda una reunión con nosotros y haznos saber tus necesidades y/o problemas. Responderemos todas tus consultas y te daremos a conocer las soluciones que McLab tiene para tu empresa.</p>
            </div>
        </div>
        <div class="row ">
            <div class="col-lg-12 text-center">
                <a href="mailto:contacto@mclab.cl" class="btn btn-primary">Envíanos un correo</a>
            </div>
        </div>
        <div class="row d-flex justify-content-center">
            <div class="col-lg-8 col-lg-offset-2 text-center m-t-lg m-b-lg">
                <p><strong>© {{currentYear}} McLab, SpA</strong></p>
            </div>
        </div>
    </div>
</section>
